import React from "react";
import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import ChannelGrid from "../MarketingChannelGrids/ChannelGrid.jsx";
import {GridType} from "../MarketingChannelGrids/channelGridColumnSetup.js";


export default function OrderMarketingProfitabilityOverview({project}) {

    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-profitability')} showMarketingFilters={true}>
            <ChannelGrid project={project} gridType={GridType.MarketingProfitability}/>
    </OrderDashboardLayout>;
}
